export default __webpack_public_path__ + "static/media/img (2).2e835f75.jpg";